import Page from './pages';
import Module from './modules';

export default {
  PERMISSION_ADMIN_DASHBOARD_PAGE : 'admin_dashboard',
  PERMISSION_ADMIN_ABONNEMENTS : 'admin_abonnements',
  PERMISSION_ADMIN_HISTORIC : 'admin_historic',

  PERMISSION_DASHBOARD_PAGE : 'dashboard',
  PERMISSION_DASHBOARD_VIEW : 'dashboard_view',
  PERMISSION_DASHBOARD_MENU : 'menu',
  PERMISSION_DASHBOARD_MENU_VIEW : 'menu_view',

  PERMISSION_NEOPASS_PAGE : 'neopass',
  PERMISSION_NEOPASS_LISTE : 'neopass_list',
  PERMISSION_NEOPASS_EXPORT : 'neopass_export',
  PERMISSION_NEOPASS_NEOPASS_HISTORY : 'neopass_historic',
  PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE : 'neopass_add',
  PERMISSION_NEOPASS_PARAMETRES_DROITS_ACCES : 'neopass_rights',
  PERMISSION_NEOPASS_DETACHER : 'neopass_detach',
  PERMISSION_NEOPASS_DESACTIVER : 'neopass_disable',
  PERMISSION_NEOPASS_SUPPRIMER : 'neopass_delete',

  PERMISSION_MODELE_DE_PAGE_PAGE : 'templates',
  PERMISSION_MODELE_DE_PAGE_DESACTIVER : 'templates_disable',
  PERMISSION_MODELE_DE_PAGE_SUPPRIMER : 'templates_delete',
  PERMISSION_MODELE_DE_PAGE_REACTIVER : 'templates_reactivate',
  PERMISSION_MODELE_DE_PAGE_AJOUTER_MODELE : 'templates_add',
  PERMISSION_MODELE_DE_PAGE_EDITER : 'templates_edit',
  PERMISSION_MODELE_DE_PAGE_APERCU : 'template_preview',

  PERMISSION_CARTOGRAPHIE_COLLECTIVE_PAGE : 'collectives',
  PERMISSION_CARTOGRAPHIE_COLLECTIVE_DISPLAY : 'display_collectives',
  PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE : 'cartography_collective_compare',

  PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_PAGE : 'individuelles',
  PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_DISPLAY : 'display_individuelles',
  PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE : 'cartography_individual_compare',

  PERMISSION_FICHE_DE_POSTE_PAGE : 'job_description',
  PERMISSION_FICHE_DE_POSTE_PERSONNELLE_LISTE : 'job_description_personnal_list',
  PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EXPORTER : 'job_description_personnal_export',
  PERMISSION_FICHE_DE_POSTE_PERSONNELLE_SUPPRIMER : 'job_description_personnal_delete',
  PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER : 'job_description_personnal_edit',
  PERMISSION_FICHE_DE_POSTE_PERSONNELLE_CONSULTER : 'job_description_personnal_read',
  PERMISSION_FICHE_DE_POSTE_PERSONNELLE_AJOUTER_FICHE : 'job_description_personnal_add',
  PERMISSION_FICHE_DE_POSTE_PERSONNELLE_TELECHARGER_MODELE : 'job_description_personnal_download_template',
  PERMISSION_FICHE_DE_POSTE_PERSONNELLE_TELECHARGER_INSTRUCTIONS : 'job_description_personnal_download_instructions',
  PERMISSION_FICHE_DE_POSTE_COMMUNE_LISTE : 'job_description_shared_list',
  PERMISSION_FICHE_DE_POSTE_COMMUNE_EXPORTER : 'job_description_shared_export',
  PERMISSION_FICHE_DE_POSTE_COMMUNE_SUPPRIMER : 'job_description_shared_delete',
  PERMISSION_FICHE_DE_POSTE_COMMUNE_EDITER : 'job_description_shared_edit',
  PERMISSION_FICHE_DE_POSTE_COMMUNE_CONSULTER : 'job_description_shared_read',
  PERMISSION_FICHE_DE_POSTE_COMMUNE_AJOUTER_FICHE : 'job_description_shared_add',
  PERMISSION_FICHE_DE_POSTE_COMMUNE_AJOUTER_DANS_BIBLIOTHEQUE_PERSONNELLE : 'job_description_shared_add_to_personnal',

  PERMISSION_REFERENTIEL_FORMATION_PAGE : 'ref_formations',
  PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_LISTE : 'ref_formations_personnal_list',
  PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EXPORTER : 'ref_formations_personnal_export',
  PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_SUPPRIMER : 'ref_formations_personnal_delete',
  PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER : 'ref_formations_personnal_edit',
  PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_CONSULTER : 'ref_formations_personnal_read',
  PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_AJOUTER_FICHE : 'ref_formations_personnal_add',
  PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_TELECHARGER_MODELE : 'ref_formations_personnal_download_template',
  PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_TELECHARGER_INSTRUCTIONS : 'ref_formations_personnal_download_instructions',
  PERMISSION_REFERENTIEL_FORMATION_COMMUNE_LISTE : 'ref_formations_shared_list',
  PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EXPORTER : 'ref_formations_shared_export',
  PERMISSION_REFERENTIEL_FORMATION_COMMUNE_SUPPRIMER : 'ref_formations_shared_delete',
  PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EDITER : 'ref_formations_shared_edit',
  PERMISSION_REFERENTIEL_FORMATION_COMMUNE_CONSULTER : 'ref_formations_shared_read',
  PERMISSION_REFERENTIEL_FORMATION_COMMUNE_AJOUTER_FICHE : 'ref_formations_shared_add',
  PERMISSION_REFERENTIEL_FORMATION_COMMUNE_AJOUTER_DANS_BIBLIOTHEQUE_PERSONNELLE : 'ref_formations_shared_add_to_personnal',

  PERMISSION_DEPOT_DOCUMENTS_PAGE : 'depot_documents',
  PERMISSION_DEPOT_DOCUMENTS_EDIT : 'documents_edit_folder',
  PERMISSION_DEPOT_DOCUMENTS_DELETE : 'documents_delete',
  PERMISSION_DEPOT_DOCUMENTS_CREATE : 'documents_create',
  PERMISSION_DEPOT_DOCUMENTS_SHARE : 'documents_share',
  PERMISSION_DEPOT_DOCUMENTS_MOVE : 'documents_move',

  PERMISSION_CURRICULUM_VITAE_PAGE : 'curriculum_vitae',

  PERMISSION_RECHERCHE_COMPETENCES_PAGE : 'recherche_competences',

  PERMISSION_AIDE_PAGE : 'help',
  PERMISSION_AIDE_CONSULTER : 'help_read',

  PERMISSION_NEOPASS_FORM_PAGE : 'neopass_form',

  PERMISSION_NEOPASS_FORM_CV_PROFESSIONNEL_CONSULTER : Module.MODULE_NEOPASS_FORM_CV_PROFESSIONNEL+'_read',
  PERMISSION_NEOPASS_FORM_CV_PROFESSIONNEL_EDITER : Module.MODULE_NEOPASS_FORM_CV_PROFESSIONNEL+'_edit',
  PERMISSION_NEOPASS_FORM_INFORMATIONS_GENERALES_CONSULTER : Page.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES+'_read',
  PERMISSION_NEOPASS_FORM_INFORMATIONS_GENERALES_EDITER : Page.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES+'_edit',
  PERMISSION_NEOPASS_FORM_SITUATION_PERSONNELLE_CONSULTER : Page.PAGE_NEOPASS_FORM_SITUATION_PERSONNELLE+'_read',
  PERMISSION_NEOPASS_FORM_SITUATION_PERSONNELLE_EDITER : Page.PAGE_NEOPASS_FORM_SITUATION_PERSONNELLE+'_edit',
  PERMISSION_NEOPASS_FORM_SITUATION_PROFESSIONNELLE_CONSULTER : Page.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE+'_read',
  PERMISSION_NEOPASS_FORM_SITUATION_PROFESSIONNELLE_EDITER : Page.PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE+'_edit',
  PERMISSION_NEOPASS_FORM_PARCOURS_CONSULTER : Page.PAGE_NEOPASS_FORM_PARCOURS+'_read',
  PERMISSION_NEOPASS_FORM_PARCOURS_EDITER : Page.PAGE_NEOPASS_FORM_PARCOURS+'_edit',
  PERMISSION_NEOPASS_FORM_PORTFOLIO_CONSULTER : Page.PAGE_NEOPASS_FORM_PORTFOLIO+'_read',
  PERMISSION_NEOPASS_FORM_PORTFOLIO_EDITER : Page.PAGE_NEOPASS_FORM_PORTFOLIO+'_edit',

  PERMISSION_NEOPASS_FORM_COMPETENCES_PERSONNELLES_CONSULTER : Module.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES+'_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_PERSONNELLES_EDITER : Module.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES+'_edit',
  PERMISSION_NEOPASS_FORM_ACTIVITES_EXTRA_PRO_CONSULTER : Page.PAGE_NEOPASS_FORM_ACTIVITES_EXTRA_PRO+'_read',
  PERMISSION_NEOPASS_FORM_ACTIVITES_EXTRA_PRO_EDITER : Page.PAGE_NEOPASS_FORM_ACTIVITES_EXTRA_PRO+'_edit',
  PERMISSION_NEOPASS_FORM_COMPETENCES_CLES_CONSULTER : Page.PAGE_NEOPASS_FORM_COMPETENCES_CLES+'_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_CLES_EDITER : Page.PAGE_NEOPASS_FORM_COMPETENCES_CLES+'_edit',
  PERMISSION_NEOPASS_FORM_NIVEAU_INFORMATIQUE_CONSULTER : Page.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE+'_read',
  PERMISSION_NEOPASS_FORM_NIVEAU_INFORMATIQUE_EDITER : Page.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE+'_edit',
  PERMISSION_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES_CONSULTER : Page.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES+'_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES_EDITER : Page.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES+'_edit',

  PERMISSION_NEOPASS_FORM_COMPETENCES_SOCIO_PRO_CONSULTER : Module.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO+'_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_SOCIO_PRO_EDITER : Module.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO+'_edit',
  PERMISSION_NEOPASS_FORM_COMPETENCES_SOCIO_PRO_AUTO_EVAL_CONSULTER : Module.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO+'_auto_eval_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_SOCIO_PRO_AUTO_EVAL_EDITER : Module.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO+'_auto_eval_edit',
  PERMISSION_NEOPASS_FORM_APTITUDES_PERSONNELLES_CONSULTER : Page.PAGE_NEOPASS_FORM_APTITUDES_PERSONNELLES+'_read',
  PERMISSION_NEOPASS_FORM_APTITUDES_PERSONNELLES_EDITER : Page.PAGE_NEOPASS_FORM_APTITUDES_PERSONNELLES+'_edit',
  PERMISSION_NEOPASS_FORM_COMPORTEMENT_SOCIAL_RELATIONNEL_CONSULTER : Page.PAGE_NEOPASS_FORM_COMPORTEMENT_SOCIAL_RELATIONNEL+'_read',
  PERMISSION_NEOPASS_FORM_COMPORTEMENT_SOCIAL_RELATIONNEL_EDITER : Page.PAGE_NEOPASS_FORM_COMPORTEMENT_SOCIAL_RELATIONNEL+'_edit',
  PERMISSION_NEOPASS_FORM_APTITUDES_TRAVAIL_CONSULTER : Page.PAGE_NEOPASS_FORM_APTITUDES_TRAVAIL+'_read',
  PERMISSION_NEOPASS_FORM_APTITUDES_TRAVAIL_EDITER : Page.PAGE_NEOPASS_FORM_APTITUDES_TRAVAIL+'_edit',
  PERMISSION_NEOPASS_FORM_PRODUCTIVITE_TECHNICITE_CONSULTER : Page.PAGE_NEOPASS_FORM_PRODUCTIVITE_TECHNICITE+'_read',
  PERMISSION_NEOPASS_FORM_PRODUCTIVITE_TECHNICITE_EDITER : Page.PAGE_NEOPASS_FORM_PRODUCTIVITE_TECHNICITE+'_edit',
  PERMISSION_NEOPASS_FORM_ATTITUDES_TRAVAIL_CONSULTER : Page.PAGE_NEOPASS_FORM_ATTITUDES_TRAVAIL+'_read',
  PERMISSION_NEOPASS_FORM_ATTITUDES_TRAVAIL_EDITER : Page.PAGE_NEOPASS_FORM_ATTITUDES_TRAVAIL+'_edit',
  PERMISSION_NEOPASS_FORM_RAPPORT_REGLES_CONTRAINTES_CONSULTER : Page.PAGE_NEOPASS_FORM_RAPPORT_REGLES_CONTRAINTES+'_read',
  PERMISSION_NEOPASS_FORM_RAPPORT_REGLES_CONTRAINTES_EDITER : Page.PAGE_NEOPASS_FORM_RAPPORT_REGLES_CONTRAINTES+'_edit',

  PERMISSION_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES_CONSULTER : Module.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES+'_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES_EDITER : Module.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES+'_edit',
  PERMISSION_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES_AUTO_EVAL_CONSULTER : Module.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES+'_auto_eval_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES_AUTO_EVAL_EDITER : Module.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES+'_auto_eval_edit',
  PERMISSION_NEOPASS_FORM_POSTE_1_CONSULTER : Page.PAGE_NEOPASS_FORM_POSTE_1+'_read',
  PERMISSION_NEOPASS_FORM_POSTE_1_EDITER : Page.PAGE_NEOPASS_FORM_POSTE_1+'_edit',
  PERMISSION_NEOPASS_FORM_POSTE_2_CONSULTER : Page.PAGE_NEOPASS_FORM_POSTE_2+'_read',
  PERMISSION_NEOPASS_FORM_POSTE_2_EDITER : Page.PAGE_NEOPASS_FORM_POSTE_2+'_edit',
  PERMISSION_NEOPASS_FORM_POSTE_3_CONSULTER : Page.PAGE_NEOPASS_FORM_POSTE_3+'_read',
  PERMISSION_NEOPASS_FORM_POSTE_3_EDITER : Page.PAGE_NEOPASS_FORM_POSTE_3+'_edit',
  PERMISSION_NEOPASS_FORM_POSTE_4_CONSULTER : Page.PAGE_NEOPASS_FORM_POSTE_4+'_read',
  PERMISSION_NEOPASS_FORM_POSTE_4_EDITER : Page.PAGE_NEOPASS_FORM_POSTE_4+'_edit',
  PERMISSION_NEOPASS_FORM_POSTE_5_CONSULTER : Page.PAGE_NEOPASS_FORM_POSTE_5+'_read',
  PERMISSION_NEOPASS_FORM_POSTE_5_EDITER : Page.PAGE_NEOPASS_FORM_POSTE_5+'_edit',

  PERMISSION_NEOPASS_FORM_COMPETENCES_SCOLAIRES_CONSULTER : Module.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES+'_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_SCOLAIRES_EDITER : Module.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES+'_edit',
  PERMISSION_NEOPASS_FORM_COMPETENCES_SCOLAIRES_AUTO_EVAL_CONSULTER : Module.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES+'_auto_eval_read',
  PERMISSION_NEOPASS_FORM_COMPETENCES_SCOLAIRES_AUTO_EVAL_EDITER : Module.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES+'_auto_eval_edit',
  PERMISSION_NEOPASS_FORM_FORMATION_1_CONSULTER : Page.PAGE_NEOPASS_FORM_FORMATION_1+'_read',
  PERMISSION_NEOPASS_FORM_FORMATION_1_EDITER : Page.PAGE_NEOPASS_FORM_FORMATION_1+'_edit',
  PERMISSION_NEOPASS_FORM_FORMATION_2_CONSULTER : Page.PAGE_NEOPASS_FORM_FORMATION_2+'_read',
  PERMISSION_NEOPASS_FORM_FORMATION_2_EDITER : Page.PAGE_NEOPASS_FORM_FORMATION_2+'_edit',
  PERMISSION_NEOPASS_FORM_FORMATION_3_CONSULTER : Page.PAGE_NEOPASS_FORM_FORMATION_3+'_read',
  PERMISSION_NEOPASS_FORM_FORMATION_3_EDITER : Page.PAGE_NEOPASS_FORM_FORMATION_3+'_edit',
  PERMISSION_NEOPASS_FORM_FORMATION_4_CONSULTER : Page.PAGE_NEOPASS_FORM_FORMATION_4+'_read',
  PERMISSION_NEOPASS_FORM_FORMATION_4_EDITER : Page.PAGE_NEOPASS_FORM_FORMATION_4+'_edit',
  PERMISSION_NEOPASS_FORM_FORMATION_5_CONSULTER : Page.PAGE_NEOPASS_FORM_FORMATION_5+'_read',
  PERMISSION_NEOPASS_FORM_FORMATION_5_EDITER : Page.PAGE_NEOPASS_FORM_FORMATION_5+'_edit',

  PERMISSION_NEOPASS_FORM_PLAN_ACCOMPAGNEMENT_CONSULTER : Module.MODULE_NEOPASS_FORM_PLAN_ACCOMPAGNEMENT+'_read',
  PERMISSION_NEOPASS_FORM_PLAN_ACCOMPAGNEMENT_EDITER : Module.MODULE_NEOPASS_FORM_PLAN_ACCOMPAGNEMENT+'_edit',
  PERMISSION_NEOPASS_FORM_BILANS_CONSULTER : Page.PAGE_NEOPASS_FORM_BILANS+'_read',
  PERMISSION_NEOPASS_FORM_BILANS_EDITER : Page.PAGE_NEOPASS_FORM_BILANS+'_edit',
  PERMISSION_NEOPASS_FORM_PROJETS_CONSULTER : Page.PAGE_NEOPASS_FORM_PROJETS+'_read',
  PERMISSION_NEOPASS_FORM_PROJETS_EDITER : Page.PAGE_NEOPASS_FORM_PROJETS+'_edit',

  PERMISSION_NEOPASS_FORM_PRECONISATIONS_CONSULTER : Module.MODULE_NEOPASS_FORM_PRECONISATIONS+'_read',
  PERMISSION_NEOPASS_FORM_PRECONISATIONS_EDITER : Module.MODULE_NEOPASS_FORM_PRECONISATIONS+'_edit',
  PERMISSION_NEOPASS_FORM_ACCESSIBILITE_CONSULTER : Page.PAGE_NEOPASS_FORM_ACCESSIBILITE+'_read',
  PERMISSION_NEOPASS_FORM_ACCESSIBILITE_EDITER : Page.PAGE_NEOPASS_FORM_ACCESSIBILITE+'_edit',
  PERMISSION_NEOPASS_FORM_POSTE_DE_TRAVAIL_CONSULTER : Page.PAGE_NEOPASS_FORM_POSTE_DE_TRAVAIL+'_read',
  PERMISSION_NEOPASS_FORM_POSTE_DE_TRAVAIL_EDITER : Page.PAGE_NEOPASS_FORM_POSTE_DE_TRAVAIL+'_edit',
  PERMISSION_NEOPASS_FORM_AUTONOMIE_CONSULTER : Page.PAGE_NEOPASS_FORM_AUTONOMIE+'_read',
  PERMISSION_NEOPASS_FORM_AUTONOMIE_EDITER : Page.PAGE_NEOPASS_FORM_AUTONOMIE+'_edit',

  PERMISSION_NEOPASS_FORM_DEPOT_DOCUMENTS_CONSULTER : Module.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS+'_read',
  PERMISSION_NEOPASS_FORM_DOCUMENTS_CONSULTER : Page.PAGE_NEOPASS_FORM_DOCUMENTS+'_read',
  PERMISSION_NEOPASS_FORM_DEPOT_DOCUMENTS_EDITER : Module.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS+'_edit',
  PERMISSION_NEOPASS_FORM_DOCUMENTS_EDITER : Page.PAGE_NEOPASS_FORM_DOCUMENTS+'_edit',

  PERMISSION_GESTION_DROITS_PAGE : 'droits_restrictions',
  PERMISSION_GESTION_DROITS_ROLE_LISTE : 'roles',
  PERMISSION_GESTION_DROITS_ROLE_AJOUTER : 'role_add',
  PERMISSION_GESTION_DROITS_ROLE_EDITER : 'role_edit',
  PERMISSION_GESTION_DROITS_ROLE_SUPPRIMER : 'role_delete',
  PERMISSION_GESTION_DROITS_REFERENT_LISTE : 'referents',
  PERMISSION_GESTION_DROITS_REFERENT_AJOUTER : 'referent_add',
  PERMISSION_GESTION_DROITS_REFERENT_EDITER : 'referent_edit',
  PERMISSION_GESTION_DROITS_REFERENT_DROITS_SUR_NEOPASS : 'referent_rights_neopass_edit',
  PERMISSION_GESTION_DROITS_REFERENT_DESACTIVER : 'referent_disable',
  PERMISSION_GESTION_DROITS_REFERENT_SUPPRIMER : 'referent_delete',
  PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE : 'beneficiaires',
  PERMISSION_GESTION_DROITS_BENEFICIAIRE_EDITER : 'beneficiaire_edit',
  PERMISSION_GESTION_DROITS_BENEFICIAIRE_DROITS : 'beneficiaire_rights_edit',
  PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE : 'beneficiaire_templates_edit',

  PERMISSION_PARAMETRE_COMPTE_PAGE : 'parametres_compte',
  PERMISSION_PARAMETRE_COMPTE_INFORMATIONS_COMPTE : 'informations_compte',
  PERMISSION_PARAMETRE_COMPTE_ABONNEMENT : 'abonnement',
  PERMISSION_PARAMETRE_COMPTE_CHANGER_METHODE_PAIEMENT : 'change_payment_method',
  PERMISSION_PARAMETRE_COMPTE_CHANGER_ABONNEMENT : 'change_subscription',
  PERMISSION_PARAMETRE_COMPTE_HISTORIQUE_FACTURE : 'historique_factures',
  PERMISSION_PARAMETRE_COMPTE_OFFRE_LISTE : 'offres_neopass',
  PERMISSION_PARAMETRE_COMPTE_MODULE_LISTE : 'modules_list',
  PERMISSION_PARAMETRE_COMPTE_PAIEMENT : 'paiement',
};